import { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { RefType } from "../../types";
import { CheckboxBase, CheckboxBaseProps } from "../inputs/Checkbox";

import styles from "./styles.module.scss";

export type TagSize = "sm" | "md" | "lg";

export type TagProps = HtmlHTMLAttributes<HTMLDivElement> & {
  ref?: RefType<HTMLDivElement>
  tagSize?: TagSize,
  checkboxProps?: Omit<CheckboxBaseProps, "checkboxBaseSize">,
  startAdornment?: ReactNode,
  endAdornment?: ReactNode,
}

export const Tag = memo<TagProps>(forwardRef((
  {
    className,
    children,
    tagSize = "md",
    checkboxProps,
    startAdornment,
    endAdornment,
    ...props
  },
  ref,
) => {
  const hasStartAdornment = !!checkboxProps || !!startAdornment;
  const hasEndAdornment = !!endAdornment;

  return (
    <div
      className={classNames(
        className,
        styles.root,
        styles[tagSize as keyof typeof styles],
        {
          [styles.withStartAdornment]: hasStartAdornment,
          [styles.withEndAdornment]: hasEndAdornment,
        },
      )}
      data-tag-size={tagSize}
      ref={ref}
      {...props}
    >
      {
        checkboxProps &&
        <CheckboxBase
          {...checkboxProps}
          className={classNames(styles.checkbox, checkboxProps.className)}
          checkboxBaseSize="sm"
        />
      }
      {startAdornment}
      {children}
      {endAdornment}
    </div>
  );
}));